import Syn1 from "./Syn1";
import "./Synonyms.css";

export default function Synonyms(props) {
  // console.log(props.info);
  if (props.info.meanings[0].definitions[0].synonyms) {
    return (
      <section>
        Synonyms:
        {props.info.meanings.map(function (meanings, index) {
          return (
            <div key={index}>
              <Syn1 meanings={meanings} />
            </div>
          );
        })}
      </section>
    );
  } else {
    return null;
  }
}
